import { render, staticRenderFns } from "./ButtonGooglePlayDefs.vue?vue&type=template&id=30d82f2c&"
import script from "./ButtonGooglePlayDefs.vue?vue&type=script&lang=js&"
export * from "./ButtonGooglePlayDefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports